import { Platform } from 'react-native';

const MobileOnly = ({ children }: { children: JSX.Element }) =>
  (Platform.OS === 'ios' || Platform.OS === 'android') && children
    ? children
    : null;

export default MobileOnly;
